import { HttpClient } from '@angular/common/http';
import { Component, input, OnInit, signal } from '@angular/core';
import { AppConfig } from '@app/app.config';
import { IVersion } from '@app/shared/models/version.model';
import { environment } from '@env/environment';
import { UntilDestroy } from '@ngneat/until-destroy';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';
import { StorageService } from '@app/core/services/client-services/storage-service/storage.service';
import { MatTooltip } from '@angular/material/tooltip';

@UntilDestroy({ checkProperties: true })
@Component({
    selector: 'app-unauth-footer',
    templateUrl: './unauth-footer.component.html',
    styleUrls: ['./unauth-footer.component.scss'],
    imports: [MatTooltip, TranslateModule],
})
export class UnauthFooterComponent implements OnInit {
    page = input<string>();

    availableLanguages = environment.availableLanguages.filter(
        lang => lang.code === 'de' || lang.code === 'en'
    );
    versionString = signal('');

    constructor(
        private translate: TranslateService,
        public appConfig: AppConfig,
        private http: HttpClient,
        private storageService: StorageService
    ) {}

    async ngOnInit() {
        try {
            const version = await lastValueFrom(
                this.http.get<IVersion>(
                    `assets/version.json?v=${new Date().getTime()}`
                )
            );
            if (version) {
                let versionString = '';
                if (version.release) {
                    versionString += `Release:\n${version.release}\n`;
                }
                if (version.commit) {
                    versionString += `Commit ID:\n${version.commit}`;
                }
                this.versionString.set(versionString);
            }
        } catch (error) {}
    }

    public changeLanguage(code: string) {
        this.translate.use(code);
        this.storageService.setItem('language_code', code);
    }
}
